import { createReducer, on } from '@ngrx/store';
import {
  getGmails,
  getGmailsFailure,
  getGmailsSuccess,
} from './google.actions';

export interface GoogleState {
  error: string;
  isLoading: boolean;
  gmails: any;
  calendar: any;
}

const initialState: GoogleState = {
  error: null,
  isLoading: false,
  gmails: null,
  calendar: null,
};

export const googleReducer = createReducer(
  initialState,
  on(getGmails, (state) => {
    return { ...state, gmails: null, isLoading: true, error: null };
  }),
  on(getGmailsSuccess, (state, { new_gmails }) => {
    return { ...state, gmails : new_gmails, isLoading: false, error: null };
  }),
  on(getGmailsFailure, (state, { error }) => {
    return { ...state, isLoading: true, error };
  })
);
